import { useState } from 'react'
import { shallow } from 'zustand/shallow'
import { useForm } from 'react-hook-form'

import Button from 'src/ui/atoms/Button'
import Modal from 'src/ui/atoms/Modal'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'
import NetworkAndChainSelector from 'src/ui/molecules/NetworkAndChainSelector'
import { useChainAndNetwork } from 'src/store/chainAndNetwork'
import useProjectsApi from './useProjectsApi'

const ImportProject = () => {
  const [modal, setModal] = useState(false)
  const { chain, network } = useChainAndNetwork(
    (state) => ({
      chain: state.chain,
      network: state.network,
    }),
    shallow,
  )
  const { importProject } = useProjectsApi()

  const handleImportProject = async (data: { tokenTicker: string; address: string }) => {
    importProject({
      chain,
      network,
      tokenTicker: data.tokenTicker,
      address: data.address,
    })
  }

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })

  return (
    <div>
      <Button
        size="M"
        name="Import project"
        onClick={() => {
          setModal(true)
        }}
      />
      {modal && (
        <Modal title="Import project">
          <NetworkAndChainSelector withTitle={false} />

          <form
            className="flex flex-col gap-4"
            onSubmit={handleSubmit((data) => handleImportProject(data as any))}>
            {chain === 'multiversx' ? (
              <WrappedInput
                placeholder="Token ticker"
                label="Token ticker"
                error={errors.tokenTicker}
                {...register('tokenTicker', {
                  required: 'Required field.',
                })}
              />
            ) : (
              <WrappedInput
                placeholder="Address"
                label="Address"
                error={errors.address}
                {...register('address', {
                  required: 'Required field.',
                })}
              />
            )}

            <div className="flex justify-end gap-4">
              <Button size="M" name="Cancel" type="secondary" onClick={() => setModal(false)} />
              <Button size="M" name="Import" disabled={!isValid} />
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}

export default ImportProject
